import {useLocation} from '@github-ui/react-router'
import {Link} from '@primer/react'
import {advancedSearchPath, getRelativeHref} from '@github-ui/paths'
import type {SearchKind} from '../../hooks/use-search-result-counts'
import styles from './Footer.module.css'

export default function Footer({resultKind}: {resultKind: SearchKind}) {
  const {search} = useLocation()
  const query = new URLSearchParams(search).get('q')
  const href = getRelativeHref(advancedSearchPath, undefined, {q: query})

  if (resultKind.name === 'code') {
    return null
  }

  return (
    <p className={styles.footer}>
      You could try an{' '}
      <Link inline href={href}>
        advanced search
      </Link>
      .
    </p>
  )
}
